module.exports = [
  'Chrome >= 49',
  'ChromeAndroid >= 49',
  'Edge >= 79',
  'Firefox >= 52',
  'FirefoxAndroid >= 68',
  'iOS >= 10',
  'Opera >= 67',
  'QQAndroid >= 10.4',
  'Safari >= 11.1',
  'Samsung >= 5',
  'UCAndroid >= 12.12',
];
